module.exports = __webpack_public_path__ + "img/27.aa014cd3.svg";